import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import MainLayout from './components/Layout/MainLayout.jsx';  // Add .jsx extension
import Scanner from './components/Scanner/Scanner.jsx';       // Add .jsx extension
import ScanHistoryView from './components/ScanHistory/ScanHistoryView.jsx';  // Add .jsx extension
import ReportsView from './components/Reports/ReportsView.jsx';  // Add .jsx extension
import ProfileManager from './components/Profile/ProfileManager.jsx';  // Add .jsx extension
import SettingsView from './components/Settings/SettingsView.jsx';  // Add .jsx extension
import PaymentSuccess from './components/Purchase/PaymentSuccess.jsx';  // Aggiungo l'import
import DomainVerificationPage from './components/DomainVerification/DomainVerificationPage.jsx';
import LoginPage from './components/Auth/LoginPage.jsx';
import ProtectedRoute from './components/ProtectedRoute';
import PlansPage from './pages/Plans/PlansPage';
import LandingPage from './pages/Landing/LandingPage';
import SubdomainScanner from './components/Scanner/SubdomainScanner';

function AppContent() {
  const { theme } = useTheme();

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route 
              path="/scan" 
              element={
                <ProtectedRoute>
                  <Scanner />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/scan/:id" 
              element={
                <ProtectedRoute>
                  <Scanner />
                </ProtectedRoute>
              } 
            />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route
              path="/domains"
              element={
                <ProtectedRoute>
                  <DomainVerificationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <ScanHistoryView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <ReportsView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfileManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subdomains/:scanId?"  // Changed from "/subdomains" to support scanId parameter
              element={
                <ProtectedRoute>
                  <SubdomainScanner />
                </ProtectedRoute>
              }
            />
            <Route path="/plans" element={<PlansPage />} />
          </Routes>
        </MainLayout>
      </Router>
    </MuiThemeProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;